<template>
    <ui-page-configuration
        module-name="Empreendimentos"
        :subtitle="titleName"
        :module-link="{ name: 'products.list' }"
        :title="product?.name"
    >
        <template #sidebar-left>
            <section class="container-sidebar-left">
                <div class="sidebar-left-header">
                    <div class="icon"><em class="fal fa-building" /></div>
                    <span class="title">
                        <span>Empreendimentos</span>
                    </span>
                </div>

                <div class="sidebar-left-links">
                    <div>
                        <router-link
                            v-if="!loadingLink"
                            class="link"
                            :to="{ name: 'products.permissions' }"
                            :class="{ 'link-active': routeName == 'products.permissions' }"
                        >
                            Permissões
                            <em class="far fa-chevron-right" />
                        </router-link>

                        <router-link
                            v-if="allowDigitalSign"
                            class="link"
                            :to="{ name: 'products.digitalSign' }"
                            :class="{ 'link-active': routeName == 'products.digitalSign' }"
                        >
                            Assinatura Digital
                            <em class="far fa-chevron-right" />
                        </router-link>

                        <router-link
                            v-if="!loadingLink && hasUnitsExclusives?.active"
                            class="link"
                            :to="{ name: 'products.exclusiveUnits' }"
                            :class="{ 'link-active': routeName == 'products.exclusiveUnits' }"
                        >
                            Unidades Exclusivas
                            <em class="far fa-chevron-right" />
                        </router-link>

                        <div v-if="loadingLink" class="loading-link">
                            <ui-load-indicator :h="30" :stroke="4" bg-color="#DFE5EC" color="#69D296" />
                        </div>
                    </div>
                </div>
            </section>
        </template>

        <template v-if="routeName == 'products.exclusiveUnits'" #header-actions>
            <div class="units-and-modal-teams">
                
              
                <span v-if="selectedUnitsChecked.length != 0" class="text-you-selected">Voce selecionou <span style="font-weight: 500;">{{ selectedUnitsChecked.length > 1 ? `${selectedUnitsChecked.length} unidades` : `${selectedUnitsChecked.length} unidade` }}.</span></span>
                <ui-button
                    v-if="selectedUnitsChecked.length !== 0"
                    type="button"
                    design="md line-primary-alt"
                    @click="openNewTeamsModal"
                >
                    <i class="fal fa-plus" /> Selecionar Equipes
                </ui-button>
            </div>
        </template>

        <template #page>
            <router-view />
        </template>
    </ui-page-configuration>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'
import { uiButton } from '@/components/ui/buttons'
import { digitalSignature, reserves } from '@/services/axios'
import { storage } from '@/services/storage'
import uiPageConfiguration from '@/templates/page-configurations'
import { mapGetters } from 'vuex'

const defaultLoader = () => ({
    type: false,
    clone: false
})

export default {
    name: 'ui-products-configurations',

    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },

    components: {
        uiPageConfiguration,
        uiLoadIndicator,
        uiButton
    },

    data() {
        return {
            digitalSign: false,
            linkActive: true,
            loadingLink: false,
            hasUnitsExclusives: false
        }
    },

    computed: {
        ...mapGetters('digitalSignatureStore', {
            loading: 'getLoading',
            product: 'getProduct'
        }),
        ...mapGetters('exclusiveManagement', ['getSelectedUnitsChecked', 'getHasSummary', 'handleSelectedUnitsChecked']),
        /**
         * Verifica o tipo de usuário e traz o menu na tela
         */
        user() {
            return JSON.parse(storage.get('user_logged'))
        },
        /**
         * Computed property que define se o acesso a página de configuração de modelos
         * de assinatura está liberado
         */
        allowDigitalSign() {
            return this.digitalSign && this.user?.user_group === 'admin'
        },
        /**
         * Computed property que retorna o nome da rota atual
         */
        routeName() {
            return this.$route.name // Obtém o nome da rota atual
        },
        /**
         * Computed property que retorna o nome do titulo atual
         */
        titleName(){
            switch (this.routeName) {
                case 'products.permissions':
                    return 'Permissões'
                case 'products.digitalSign':
                    return 'Assinatura Digital'
                case 'products.exclusiveUnits':
                    return 'Unidades Exclusivas'
            }
        },

        selectedUnitsChecked() {
            if(this.getHasSummary) return this.getSelectedUnitsChecked
            return [];
        }
    },

    async created() {
        this.$router.push({ name: 'products.permissions' })

        if (this.user?.user_group !== 'admin') {
            this.$router.push({ name: 'products.list' })
        }

        const { data } = await reserves.getConfigGlobal({ type: 'limit_units_teams' })
        this.hasUnitsExclusives = data.data.global_reserves_limit_units_teams
    },

    mounted() {
        this.loadDigitalSign()
        this.$root.$on('name-permissions-units', payload => {
            this.product.name = payload
        })
    },
    beforeDestroy() {
        this.handleSelectedUnitsChecked([])

    },
    methods: {
        /**
         * Carrega as opções de integração de Assinatura Digital
         */
        async loadDigitalSign() {
            this.loadingLink = true
            return await digitalSignature.getAllV2('verify-resource')
            .then(response => {
                this.digitalSign = response.data.active
                this.loadingLink = false
            })
            .catch(error => {
                if (error?.data?.msg) this.$toastr.e(error.data.msg)
                this.loadingLink = false
            })
        },

        openNewTeamsModal() {
            this.$root.$emit('modal-msg-open-new-teams-modal')
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>